import React, { memo } from 'react';
import { PreviewBasicProfilePage } from '@redlink/components/pages';
import { useValues } from '@redlink/assets/values';
import { LoadingContainer } from '@redlink/components/atoms';
import { useQuery, getPagePreviewSettingQuery } from '@redlink/services';
import { useNavigation, StackActions } from '@react-navigation/native';
import { PreviewTabNavigator } from './previewTabBavigator';
import { CompatibleContainer } from './compatibleContainer';

export const PreviewDashboardPage = memo(({ route }) => {
  const { routes } = useValues();
  const { pageName } = route.params;
  const { dispatch } = useNavigation();

  const {
    loading,
    data: { PageSettingPreview: { defaultTab, visibleTabs } = {} },
  } = useQuery(getPagePreviewSettingQuery, {
    variables: { pageName },
    failed: (e) => window.location.href = 'https://redl.ink',
  });

  return (
    <LoadingContainer isInitial hasOverlay={false} isBusy={loading}>
      <PreviewTabNavigator {...{ pageName, defaultTab, visibleTabs }} />
    </LoadingContainer>
  );
});
